<!-- Detailinfo.vue -->
<template>
	<div class="ui-detail-info" v-if="detailInfo">
		<div class="info-header ui-flex">
			<h3>{{ detailInfo.goods_name }}</h3>
			<div class="favorite">
				<i class="iconfont" v-on:click="productUnlike()" v-if="isFavorate">&#xe6d5;</i>
				<i class="iconfont" v-on:click="productLike()" v-else>&#xe6d6;</i>
				<span>{{favoriteName}}</span>
			</div>
		</div>

		<div class="price">
			<span class="current-price">￥<slot v-if="detailInfo.pintuan_type==1">{{ detailInfo.pintuan_price }}</slot><slot v-else-if="detailInfo.promotion_type">{{ detailInfo.promotion_price }}</slot><slot v-else>{{ detailInfo.goods_price }}</slot>
			</span>
			<span class="old-price" v-if="detailInfo.goods_marketprice">￥{{ detailInfo.goods_marketprice }}</span>
		</div>
		<div class="inviter_amount" v-if="detailInfo.inviter_money > 0">
			<span class="inviter_amount" >分销佣金：￥{{ detailInfo.inviter_money }}</span>
		</div>
		<div class="info-sub ui-flex" v-if="detailInfo.goods_advword">
			<p>{{ detailInfo.goods_advword }}</p>
		</div>
		<div class="info-promotions" v-if="detailInfo.pintuan_type=='pintuan'">
			<div class="left">
				<i>拼团</i>
				<span v-if="detailInfo.pintuan_limit_quantity">最多可购买{{detailInfo.pintuan_limit_quantity}}件</span>
			</div>
			<span class="right">{{fromNow(detailInfo.pintuan_end_time)}}结束</span>
		</div>
		<div class="info-promotions" v-if="detailInfo.promotion_type=='groupbuy'">
			<div class="left">
				<i>抢购</i>
				<span v-if="detailInfo.upper_limit">最多可购买{{detailInfo.upper_limit}}件</span>
			</div>
			<span class="right">{{fromNow(detailInfo.promotion_end_time)}}结束</span>
		</div>
		<div class="info-promotions" v-if="detailInfo.promotion_type=='xianshi'">
			<div class="left">
				<i>限时</i>
				<span v-if="detailInfo.lower_limit">最低{{detailInfo.lower_limit}}件起</span>
			</div>
			<span class="right">{{fromNow(detailInfo.promotion_end_time)}}结束</span>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { productLike, productUnlike } from '../../../../api/homegoodsdetail'

export default {
  data () {
    return {
      orderTime: '', // 下单时间
      arrivalsTime: '', // 到达时间
      arrivalsTitle: '', // 到达时间的标题
      arrivalsRange: '' // 到达时间区间,
    }
  },

  computed: {
    ...mapState({
      isFavorate: state => state.goodsdetail.isFavorate,
      detailInfo: state => state.goodsdetail.detailInfo,
      currentProductId: state => state.goodsdetail.currentProductId,
      user: state => state.member.info
    }),
    favoriteName () {
      return this.isFavorate ? '已关注' : '关注'
    }
  },

  created () {

  },

  methods: {
    ...mapMutations({
      changeIndex: 'changeIndex',
      saveIsFavorate: 'saveIsFavorate'
    }),
    fromNow (time) {
      return this.$moment(time * 1000).fromNow()
    },
    /*
		 * getCommentStatus： 去到评论页面
		 */
    getCommentStatus () {
      this.changeIndex(2)
    },

    /*
				productLike： 收藏商品
			*/
    productLike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productLike(id).then(res => {
          if (res) {
            this.saveIsFavorate(true)
            // this.getDetail()
          }
        })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },

    /*
				productUnlike： 取消收藏
			*/
    productUnlike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productUnlike(id).then(res => {
          if (res) {
            this.saveIsFavorate(false)
            // this.getDetail()
          }
        })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.ui-detail-info {
	padding: 0 0.75rem;
	background: #ffffff;
	.ui-flex {
		display: flex;
		/*justify-content: space-between;*/
		align-content: center;
		align-items: center;
		flex-basis: 100%;
		width: auto;
	}
	.info-header {
		padding: 0.4rem 0;
		h3 {
			color: #333;
			font-size: 0.7rem;
			padding: 0;
			margin: 0;
			font-weight: normal;
			line-height:1.2rem;
			height:2.4rem;
			width:85%;
			overflow:hidden;
		}
		.favorite {
			height:2.4rem;
			text-align:center;
			i{width:2.4rem;display:block;font-size:1.2rem;line-height:1.2rem;color:#e93b3d;}
			span{font-size:0.5rem;line-height:1rem;height:1rem;display:block;}
		}
	}

	.price {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			display: block;
			font-weight: normal;
			&.current-price {
				font-size: 0.7rem;
				color: $primaryColor;
				line-height: 1rem;
			}
			&.old-price {
				font-size: 0.6rem;
				color: rgba(164, 170, 179, 1);
				line-height: 1rem;
				text-decoration: line-through;
				margin-left: 0.3rem;
			}
		}
	}
	.inviter_amount {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			font-size: .7rem;
			color: #4e545d;
		}
	}

	.info-sub {
		border-bottom: 0.5px solid #e8eaed;
		padding-bottom: 0.25rem;
		p {
			padding: 0;
			margin: 0;
			color: $primaryColor;
			font-size: 0.5rem;
		}
	}

	.info-promotions {
		display: flex;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding: 0.75rem 0;
		border-bottom: 0.5px solid #e8eaed;
		line-height:1.5rem;
		span {
			margin-left: 0.75rem;
			font-size: 0.6rem;
			color: rgba(143, 142, 148, 1);
		}
		img {
			width: 30.4rem;
		}
	}
	.info-promotions i{font-size:.7rem;border:1px solid $primaryColor;color:$primaryColor;padding:0.1rem 0.3rem;border-radius:0.1rem;}
	.info-promotions .left{flex:1}
	.info-promotions .right{width:4rem;text-align: right}
}
</style>
